import { Avatar, Image, Space } from "antd";
import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import {
  downloadFile,
  downloadBlobFile,
} from "../../store/actions/app-actions";

import {
  DownloadOutlined,
  RotateLeftOutlined,
  RotateRightOutlined,
  SwapOutlined,
  ZoomInOutlined,
  ZoomOutOutlined,
} from "@ant-design/icons";
const defaultPic = require("../../assets/images/placeholder.jpg");

const iconsStyle = { fontSize: "24px" };

const StyledImage = ({ className, defaultValue, ...props }) => {
  const dispatch = useDispatch();
  const { src, orignalName, renderType = "image", ...restProps } = props;
  const [downloadedPic, setDownloadedPic] = useState();

  const imageProps = {
    ...props,
    src: undefined,
    renderType: undefined,
  };

  useEffect(() => {
    if (src === "default.png") {
      defaultValue && setDownloadedPic(defaultValue);
      return;
    }
    if (src) {
      const callback = (data, fileName, ext) => {
        const reader = new FileReader();
        reader.readAsDataURL(data);
        reader.onloadend = () => {
          const base64data = reader.result?.replace(
            "application/octet-stream",
            "image/jpeg"
          );
          // console.log('onReaderLoad', data, fileName, ext, base64data)
          setDownloadedPic(base64data);
        };
      };
      dispatch(downloadFile(src, callback));
    }
  }, [src, dispatch]);

  const onDownload = (fileName, originalName) => {
    const callback = (data, filename, ext) => {
      const reader = new FileReader();
      reader.readAsDataURL(data);
      reader.onloadend = () => {
        const base64data = reader.result?.replace(
          "application/octet-stream",
          "application/" + ext
        );
        let a = document.createElement("a");
        a.href = base64data;
        a.download = originalName;
        a.click();
      };
    };
    dispatch(downloadBlobFile(fileName, callback));
  };

  if (renderType === "avatar") {
    return (
      <>
        {downloadedPic ? (
          <Avatar {...imageProps} src={downloadedPic} className={className} />
        ) : (
          <Avatar {...imageProps} src={defaultPic} className={className} />
        )}
      </>
    );
  } else {
    return (
      <>
        {downloadedPic ? (
          <div {...restProps} className="styled-image overflow-hidden">
            <Image
              className={"object-cover object-center"}
              src={downloadedPic}
              preview={{
                toolbarRender: (
                  _,
                  {
                    transform: { scale },
                    actions: {
                      onFlipY,
                      onFlipX,
                      onRotateLeft,
                      onRotateRight,
                      onZoomOut,
                      onZoomIn,
                    },
                  }
                ) => (
                  <Space size={30} className="toolbar-wrapper">
                    <DownloadOutlined
                      style={iconsStyle}
                      onClick={() => onDownload(src, orignalName)}
                    />
                    <SwapOutlined
                      style={iconsStyle}
                      rotate={90}
                      onClick={onFlipY}
                    />
                    <SwapOutlined style={iconsStyle} onClick={onFlipX} />
                    <RotateLeftOutlined
                      style={iconsStyle}
                      onClick={onRotateLeft}
                    />
                    <RotateRightOutlined
                      style={iconsStyle}
                      onClick={onRotateRight}
                    />
                    <ZoomOutOutlined
                      style={iconsStyle}
                      disabled={scale === 1}
                      onClick={onZoomOut}
                    />
                    <ZoomInOutlined
                      style={iconsStyle}
                      disabled={scale === 50}
                      onClick={onZoomIn}
                    />
                  </Space>
                ),
              }}
            />
          </div>
        ) : (
          <img
            alt="styledimage"
            {...imageProps}
            src={defaultValue || defaultPic}
          />
        )}
      </>
    );
  }
};

export default StyledImage;
